module.exports = "../images/best-times-to-catch-walleye.jpg?v=a6b6ce0";